import BossModel from "@/models/BossModel";
import File from '@/models/File/File';

export default class DebitInvoiceMismatch extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/debit-invoice-mismatch';

    /**
     *
     * @type {string}
     */
    static entity = 'debitInvoiceMismatches';

    static fields() {
        return {
            id: this.attr(null),
            dossier_id: this.attr(null),
            proposal_id: this.attr(null),
            file_id: this.attr(null),
            is_send_to_customer: this.attr(null),
            is_send_to_afas: this.attr(null),
            is_processed_afas: this.attr(null),
            total_price: this.attr(null),
            invoice_number: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            file: this.belongsTo(File, 'file_id'),
        }
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .with('file')
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    File() {
        return this.getRelated('file');
    }
}
